import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import {
  faPlus,
  faInfinity,
  faEdit,
  faEye,
  faCalendarTimes,
  faEllipsisH,
} from '@fortawesome/free-solid-svg-icons';
import { LicenseService } from '@services/anpr/license.service';
import { LicenseANPR } from '@classes/anpr/licenseANPR';
import { MatIconModule } from '@angular/material/icon';
import { TooltipPosition, MatTooltipModule } from '@angular/material/tooltip';
import {
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { log } from 'console';
import { UpdateLicenseComponent } from '../update-license/update-license.component';
import { ConfirmDialogComponent } from 'app/shared/dialogs/confirm-dialog/confirm-dialog.component';
import { AddLicenseComponent } from '../add-license/add-license.component';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'app-admin-list-anpr',
  templateUrl: './admin-list-anpr.component.html',
  styleUrls: ['./admin-list-anpr.component.scss'],
})
export class AdminListAnprComponent implements OnInit {
  faPlus = faPlus;
  faInfinity = faInfinity;
  faEdit = faEdit;
  faEye = faEye;
  faEnd = faCalendarTimes;
  faMenu = faEllipsisH;
  licenses: LicenseANPR[];

  displayedColumns: string[] = [
    'client',
    'type',
    'startingDate',
    'expiryDate',
    'status',
    'usesRemaining',
    'actions',
    'comment',
  ];

  dataSource: MatTableDataSource<LicenseANPR>;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  ngOnInit(): void {
    this.getAllLicenses();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  constructor(
    private licenseService: LicenseService,
    private dialog: MatDialog,
    private _snackBar: MatSnackBar
  ) {}
  // subject pour envoyer simplement la license modifiée
  private getAllLicenses(): void {
    this.licenseService.getAllLicenses().subscribe((res) => {
      this.licenses = res;
      this.dataSource = new MatTableDataSource<LicenseANPR>(this.licenses);
      this.dataSource.filterPredicate = (data, filter: string) => {
        const accumulator = (currentTerm, key) => {
          if (key == 'client') {
            return currentTerm + data.client.name;
          }
          return currentTerm + data[key];
        };
        const dataStr = Object.keys(data).reduce(accumulator, '').toLowerCase();
        const transformedFilter = filter.trim().toLowerCase();
        return dataStr.indexOf(transformedFilter) !== -1;
      };
      this.dataSource.paginator = this.paginator;

      this.dataSource.sortingDataAccessor = (item, property) => {
        switch (property) {
          case 'client':
            return item.client.name;
          case 'type':
            return item.type.name;
          case 'status':
            return item.status.name;
          default:
            return item[property];
        }
      };
      this.dataSource.sort = this.sort;
      // rajouter les classements par colonne -> chercher "sortingdata" dans le find de VS Code
    });
  }

  // remplacer ce système par les Subject
  openUpdateLicenseDialog(element: LicenseANPR): void {
    const dialogRef = this.dialog.open(UpdateLicenseComponent, {
      height: '650px',
      width: '500px',
      data: { license: element },
    });
    dialogRef.afterClosed().subscribe((res) => {
      this.getAllLicenses();
    });
  }

  openEndLicense(element: LicenseANPR) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: 'Do you confirm the ending of this license ?',
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.licenseService.endLicense(element.id).subscribe((data) => {
          this.openSnackBar('License ended', 'OK');
          this.getAllLicenses();
        });
      }
    });
  }

  openAddLicenseDialog(): void {
    const dialogRef = this.dialog.open(AddLicenseComponent, {
      height: '650px',
      width: '500px',
    });
    dialogRef.afterClosed().subscribe((res) => {
      this.getAllLicenses();
    });
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 4000,
      // panelClass: ['green-snackbar'],
    });
  }
}
